module.exports = __webpack_public_path__ + "media/images/proof_links/ask-4fa49dedace3b1e025ff9ba26ca43030.svg";